import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Btn } from "@/components/primitives";
import { Download, Loader2, AlertTriangle } from "lucide-react";

// Fetches an authenticated PDF as a blob and renders it in an in-app iframe
// (avoids popup blockers). `path` is an API path e.g. /schedules/{id}/pdf.
export function PdfModal({ path, title, onClose }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (!path) return;
    let objUrl;
    setUrl(null); setErr(false);
    api.get(path, { responseType: "blob" })
      .then((r) => { objUrl = URL.createObjectURL(r.data); setUrl(objUrl); })
      .catch(() => setErr(true));
    return () => { if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [path]);

  return (
    <Dialog open={!!path} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-4xl w-[95vw] h-[88vh] flex flex-col p-0 gap-0">
        <DialogHeader className="px-4 py-3 border-b border-curtron-line flex-row items-center justify-between space-y-0">
          <DialogTitle className="text-base truncate">{title || "Document"}</DialogTitle>
          <DialogDescription className="sr-only">PDF document viewer</DialogDescription>
          {url && <a href={url} download={`${(title || "document").replace(/\s+/g, "_")}.pdf`}><Btn variant="secondary" className="h-8" data-testid="pdf-download-btn"><Download className="w-4 h-4" /> Download</Btn></a>}
        </DialogHeader>
        <div className="flex-1 min-h-0 bg-curtron-bg">
          {err ? (
            <div className="h-full flex flex-col items-center justify-center text-curtron-sub gap-2 px-6 text-center">
              <AlertTriangle className="w-6 h-6 text-curtron-terracotta" /> Couldn't load this PDF.
            </div>
          ) : url ? (
            <iframe src={url} title={title || "PDF"} className="w-full h-full" data-testid="pdf-iframe" />
          ) : (
            <div className="h-full flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-curtron-green" /></div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
